import { useEffect, useRef } from "react";
import { createPortal } from "react-dom";

export const portalRoot = (tableId) =>
  document.getElementById(tableId)?.parentNode?.getElementsByClassName("ant-pagination")?.item(0);

export const ColumnSelectPaginationPortal = ({ id, children }) => {
  const target = usePortal(id);
  return createPortal(children, target);
};

function usePortal(id) {
  const rootContainer = document.createElement("li");
  rootContainer.setAttribute("style", "width:30%");
  const rootElemRef = useRef(rootContainer);
  useEffect(
    function setupElement() {
      const parentElem = portalRoot(id);
      parentElem?.prepend(rootElemRef.current);
      // This function is run on unmount
      return function removeElement() {
        rootElemRef.current.remove();
      };
    },[id,portalRoot(id)]
  );
  return rootElemRef.current;
}
